import React from 'react'

const DoxNoFilesIcon = () =>
    <svg width="50" height="63" viewBox="0 0 50 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.25 0.0478516H6.25C2.8125 0.0478516 0.0312507 2.86035 0.0312507 6.29785L0 56.2979C0 59.7354 2.78125 62.5479 6.21875 62.5479H43.75C47.1875 62.5479 50 59.7354 50 56.2979V18.7979L31.25 0.0478516ZM6.25 56.2979V6.29785H28.125V21.9229H43.75V56.2979H6.25Z" fill="#D2D2D2" />
    </svg>

export default DoxNoFilesIcon